import Component from 'vue-class-component'
import CarouselEntity from './CarouselEntity'
import CarouselFactory from './CarouselFactory'
import CarouselProp    from './CarouselProp'

import {
  CarouselDirection,
  CarouselOrientation,
  CarouselTransition,
} from "@/components/Util/Layout/Carousel/CarouselInterface";
import { isNull } from "lodash";

@Component({
  name: "CarouselComponent",
})
export default class CarouselComponent extends CarouselProp {
  $refs!: {
    carousel: HTMLInputElement
  }

  cx_carousel     !: CarouselEntity
  cx_wheelTimeout !: any

  constructor() {
    super()
    this.cx_carousel = new CarouselEntity(document.createElement('div'))
  }

  /**
   * -----------------------------------------
   *                 EVENTS
   * -----------------------------------------
   */

  mounted(): void {
    this.cx_carousel = CarouselFactory.create(this.$refs.carousel)
    this.cx_carousel.slidesPerPage = CarouselFactory.setSlidesPerPage(this.slidesPerPage)
    this.cx_carousel.responsive = this.responsive
    this.cx_carousel.orientation = this.orientation as CarouselOrientation
    this.cx_carousel.transition = this.transition as CarouselTransition
    this.cx_carousel.draggable = this.draggable
    this.cx_carousel.interval = this.interval
    this.cx_carousel.showDots = this.showDots
    this.cx_carousel.showArrows = this.showArrows
    this.cx_carousel.currentSlide = this.initialSlide
    this.cx_carousel.stopOnHover = this.stopOnHover
    this.cx_carousel.wheelable = this.wheelable

    this.initDragDropNoneGhost()
    this.setListeners()
    this.cx_carousel.start()
    window.addEventListener("resize", this.onResize)
  }

  beforeUnmount(): void {
    this.cx_carousel.stop()
    window.removeEventListener("resize", this.onResize)
  }

  onResize(): void {
    this.cx_carousel.onResize()
  }

  onCarouselHovered(): void {
    this.cx_carousel.onHover()
  }

  onCarouselLeaved(): void {
    this.cx_carousel.onLeave()
  }

  onDrag(event: any): void {
    this.cx_carousel.onDrag(event)
  }

  onDragEnter(event: any): void {
    this.cx_carousel.onDragEnter(event)
  }

  onDragOver(event: any): void {
    this.cx_carousel.onDragOver(event)
  }

  onDragLeave(event: any): void {
    this.cx_carousel.onDragLeave(event)
  }

  onDragStart(event: any): void {
    this.cx_carousel.onDragStart(event)
  }

  onDragEnd(event: any): void {
    if (event.direction === CarouselDirection.LEFT)
      this.cx_carousel.incrementPage()
    else if (event.direction === CarouselDirection.RIGHT)
      this.cx_carousel.decrementPage()
  }

  onWheel(event: any): void {
    if (this.cx_carousel.wheelable) {
      clearTimeout(this.cx_wheelTimeout)

      this.cx_wheelTimeout = setTimeout(() => {
        if (event.deltaX > 0)
          this.cx_carousel.incrementPage()
        else if (event.deltaX < 0)
          this.cx_carousel.decrementPage()
      }, 50)
    }
  }

  initDragDropNoneGhost(): void {
    if (isNull(document.getElementById('drag-drop-none-image'))) {
      const img: HTMLImageElement = new Image();

      img.id = 'drag-drop-none-image'
      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs='

      img.style.display = 'block'
      img.style.width = '1px'
      img.style.height = '1px'
      img.style.position = 'absolute'
      img.style.top = '-9999px'
      img.style.left = '-9999px'

      document.body.appendChild(img)
    }
  }

  /**
   * -----------------------------------------
   *              SET LISTENERS
   * -----------------------------------------
   */

  setListeners(): void {
    this.$on('onDrag', this.onDrag)
    this.$on('onDragEnd', this.onDragEnd)
    this.$on('onDragEnter', this.onDragEnter)
    this.$on('onDragLeave', this.onDragLeave)
    this.$on('onDragOver', this.onDragOver)
    this.$on('onDragStart', this.onDragStart)
  }
}
